import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DynamicFormComponent} from './containers/dynamic-form/dynamic-form.component';

import {NgSelectModule} from '@ng-select/ng-select';
import {BaseSearchModalComponent} from '../abstract/basesearchmodal/basesearchmodal.component';
import {EventsEmitterService} from '../abstract/services/emitter.service';
import {VisualsService} from '../abstract/services/visuals.service';
import {DynamicGridModule} from '../dynamic-grid/dynamic-grid.module';

import {CURRENCY_MASK_CONFIG, CurrencyMaskConfig, CurrencyMaskModule} from 'ng2-currency-mask';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {ModalModule} from 'ngx-bootstrap/modal';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {Ng2DatetimePickerModule} from '../datepicker/ng2-datetime-picker.module';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'right',
  allowNegative: false,
  decimal: ',',
  precision: 2,
  prefix: '',
  suffix: '',
  thousands: '.',
};
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CurrencyMaskModule,
    ModalModule.forRoot(),
    CollapseModule.forRoot(),
    TooltipModule.forRoot(),
    BsDropdownModule.forRoot(),
    NgSelectModule,
    DynamicGridModule,
    Ng2DatetimePickerModule,
  ],
  declarations: [DynamicFormComponent, BaseSearchModalComponent],
  exports: [DynamicFormComponent, BaseSearchModalComponent],
  // schemas: [
  // CUSTOM_ELEMENTS_SCHEMA,
  // NO_ERRORS_SCHEMA
  // ],
  providers: [
    VisualsService,
    EventsEmitterService,
    {
      provide: CURRENCY_MASK_CONFIG,
      useValue: CustomCurrencyMaskConfig,
    },
  ],
})
export class DynamicFormModule {}
